/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Stripe Subscription data for a specific domain.
 * @export
 * @interface SubscriptionStatusData
 */
export interface SubscriptionStatusData {
    /**
     * The domain ID this subscription data belongs to
     * @type {string}
     * @memberof SubscriptionStatusData
     */
    domainId?: string;
    /**
     * The active Stripe subscription ID, if one exists
     * @type {string}
     * @memberof SubscriptionStatusData
     */
    subscriptionId?: string;
    /**
     * Whether this domain has ever had a subscription (including cancelled ones)
     * @type {boolean}
     * @memberof SubscriptionStatusData
     */
    existingSubscriptions: boolean;
    /**
     * Whether there is an active free trial subscription
     * @type {boolean}
     * @memberof SubscriptionStatusData
     */
    activeTrial: boolean;
    /**
     * Whether there is an active (trialing or paid) subscription
     * @type {boolean}
     * @memberof SubscriptionStatusData
     */
    activeSubscription: boolean;
    /**
     * Hosted Stripe invoice URL if there is an open invoice, null otherwise
     * @type {string}
     * @memberof SubscriptionStatusData
     */
    invoiceUrl?: string;
    /**
     * Amount remaining on the open invoice in the smallest currency unit (e.g. cents), null if no open invoice
     * @type {number}
     * @memberof SubscriptionStatusData
     */
    invoiceAmount?: number;
    /**
     * Currency code for the open invoice (e.g. eur, usd), null if no open invoice
     * @type {string}
     * @memberof SubscriptionStatusData
     */
    invoiceCurrency?: string;
    /**
     * Billing interval of the active subscription
     * @type {string}
     * @memberof SubscriptionStatusData
     */
    interval?: SubscriptionStatusDataIntervalEnum;
}


/**
 * @export
 */
export const SubscriptionStatusDataIntervalEnum = {
    Monthly: 'monthly',
    Yearly: 'yearly'
} as const;
export type SubscriptionStatusDataIntervalEnum = typeof SubscriptionStatusDataIntervalEnum[keyof typeof SubscriptionStatusDataIntervalEnum];


/**
 * Check if a given object implements the SubscriptionStatusData interface.
 */
export function instanceOfSubscriptionStatusData(value: object): value is SubscriptionStatusData {
    if (!('existingSubscriptions' in value) || value['existingSubscriptions'] === undefined) return false;
    if (!('activeTrial' in value) || value['activeTrial'] === undefined) return false;
    if (!('activeSubscription' in value) || value['activeSubscription'] === undefined) return false;
    return true;
}

export function SubscriptionStatusDataFromJSON(json: any): SubscriptionStatusData {
    return SubscriptionStatusDataFromJSONTyped(json, false);
}

export function SubscriptionStatusDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionStatusData {
    if (json == null) {
        return json;
    }
    return {
        
        'domainId': json['domainId'] == null ? undefined : json['domainId'],
        'subscriptionId': json['subscriptionId'] == null ? undefined : json['subscriptionId'],
        'existingSubscriptions': json['existingSubscriptions'],
        'activeTrial': json['activeTrial'],
        'activeSubscription': json['activeSubscription'],
        'invoiceUrl': json['invoiceUrl'] == null ? undefined : json['invoiceUrl'],
        'invoiceAmount': json['invoiceAmount'] == null ? undefined : json['invoiceAmount'],
        'invoiceCurrency': json['invoiceCurrency'] == null ? undefined : json['invoiceCurrency'],
        'interval': json['interval'] == null ? undefined : json['interval'],
    };
}

export function SubscriptionStatusDataToJSON(json: any): SubscriptionStatusData {
    return SubscriptionStatusDataToJSONTyped(json, false);
}

export function SubscriptionStatusDataToJSONTyped(value?: SubscriptionStatusData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'domainId': value['domainId'],
        'subscriptionId': value['subscriptionId'],
        'existingSubscriptions': value['existingSubscriptions'],
        'activeTrial': value['activeTrial'],
        'activeSubscription': value['activeSubscription'],
        'invoiceUrl': value['invoiceUrl'],
        'invoiceAmount': value['invoiceAmount'],
        'invoiceCurrency': value['invoiceCurrency'],
        'interval': value['interval'],
    };
}

